import React from "react";
import '../../../styles/components/onboarding/keyboard-setup/setup-keyboard-later-page.scss';
import Button from "../../common/Button";
import BackButton from "../../common/BackButton";
import onboarding from "../../../services/onboarding/onboarding";

export default function SetupKeyboardLater() {
  return (
    <div className="setup-keyboard-later-page">
      <header className="top">
        <BackButton/>
        <div className="overlay-text">
          <h1><span>Set up&nbsp;</span>keyboard later</h1>
        </div>
      </header>
      <div className="content-and-navigation">
        <div className="content">
          <div className="info-text">Don't want to connect a keyboard? You can still play along with lessons and songs!</div>
          <div className="steps">
            <p className="steps-label">If you decide to connect later:</p>
            <ol>
              <li>Go to the Settings section</li>
              <li>Select Keyboard & Volumes from the list</li>
              <li>Select Start Keyboard Setup</li>
            </ol>
          </div>
        </div>
        <div className="navigation">
          <div className="buttons">
            <Button buttonType="secondary" text="Start Playing" onClick={()=> onboarding.completeOnboarding() }/>
          </div>
        </div>
      </div>
    </div>
  );
}